export enum NoteType {
  DOCTOR = 'doctor',
  STAFF = 'staff',
  OTHER = 'other',
}

export enum Gender {
  M = 'M',
  F = 'F',
  O = 'O',
}

export enum CheckInMode {
  LINK = 'link',
  SMS = 'sms',
  FACIAL = 'facial',
}

export enum CurrencyCode {
  CHF = 'CHF',
  XAF = 'XAF',
  USD = 'USD',
  EUR = 'EUR',
  XOF = 'XOF',
}

export enum VerificationType {
  ByGroup = 'bygroup',
  ByHCP = 'byhcp',
}

export enum ENV {
  production = 'production',
  staging = 'staging',
  training = 'training',
  development = 'development',
}

export enum FEATURES {
  unlimited_access = 'unlimited_access',
  provider_discounts = 'provider_discounts',
  logs = 'logs',
  care_receipt = 'care_receipt',
  basic_support = 'basic_support',

  real_time_monitoring = 'real_time_monitoring',
  spend_tracking = 'spend_tracking',
  care_with_others = 'care_with_others',

  secure_chat = 'secure_chat',
  preferential_care = 'preferential_care',
  priority_support = 'priority_support',
  exclusive_content = 'exclusive_content',
}

export enum FileType {
  LegalDocument = 'legal_document',
  OtherProfil = 'other_profil',
}

export enum CategoryTypeEnum {
  PACKAGE = 'package',
  SPECIALITY = 'speciality',
}
